export const api = {
  queryPersonnelGroupListByType: '/vas/personnelControl/queryPersonnelGroupListByType.json',
  queryVehicleGroupList: 'vas/vehicleControl/queryVehicleGroupList.json'
}